import React, { useContext, useEffect, Fragment } from "react";

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import TripContext from "../../context/trip/tripContext";
import TripItem from "./TripItem";
import useInfiniteScroll from "../../hooks/useInfiniteScroll";

const PAGE_SIZE = 3;

const Trips = ({ fromPath = '/destinations' }) => {
    const tripContext = useContext(TripContext);
    const { getTrips, trips, tripsPage, tripsHasMore, loading } = tripContext;

    useEffect(() => {
        getTrips(1, PAGE_SIZE, false);
        // eslint-disable-next-line
    }, []);

    const loadMore = () => {
        getTrips((tripsPage || 1) + 1, PAGE_SIZE, true);
    };

    const sentinelRef = useInfiniteScroll(tripsHasMore, loading, loadMore);

    if ((trips === undefined || trips.length === 0) && !loading) {
        return (
            <Fragment>
                <h4>No trips to show</h4>
            </Fragment>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {trips && trips.map((trip) => (
                <TripItem key={trip.id} trip={trip} showButton={true} fromPath={fromPath} />
            ))}
            {tripsHasMore && (
                <Box ref={sentinelRef} sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                    <CircularProgress size={24} />
                </Box>
            )}
        </Box>
    );
};

export default Trips;
